import React, { useEffect, useState } from 'react';
import notificationService from '../services/notificationService';

interface Props {
  className?: string;
}

// Gentle in-app banner prompting for notification permission when default
const NotificationPermissionPrompt: React.FC<Props> = ({ className = '' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!notificationService.isNotificationSupported()) return;
    const status = notificationService.getPermissionStatus();
    setVisible(status.default);
  }, []);

  if (!visible) return null;

  return (
    <div className={`p-3 mb-3 rounded border bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300 dark:border-blue-700 relative z-10 shadow-sm ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0 pr-2">
          <div className="text-sm font-medium">Enable push notifications?</div>
          <div className="text-xs opacity-90">We'll notify you about job card updates and reminders.</div>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button
            className="px-3 py-1 text-xs rounded bg-blue-600 text-white hover:bg-blue-700"
            onClick={async () => {
              await notificationService.requestPermission();
              const status = notificationService.getPermissionStatus();
              setVisible(status.default);
            }}
          >
            Allow
          </button>
          <button
            className="px-3 py-1 text-xs rounded bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            onClick={() => setVisible(false)}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermissionPrompt;
 
